export const validations_es_AR: any = {
    validations_id_title_default: 'Sube las fotos de tu documentación.',
    validations_id_title_pre_approved: 'Tu documentación fue aprobada.',
    validations_id_title_approved: 'Tu documentación fue aprobada.',
    validations_id_title_pending: 'Tu documentación está en revisión.',
    validations_id_title_processing: 'Tu documentación está en revisión.',
    validations_id_description:
        'De esta manera, nos ayudas a verificar y respaldar que eres el titular de la cuenta con la que envías tu saldo',

    validations_biometric_title_default: 'Verifica tu identidad.',
    validations_biometric_title_pre_approved: 'Tu identidad fue verificada.',
    validations_biometric_title_approved: 'Tu identidad fue verificada.',
    validations_biometric_title_pending: 'Tu identidad está en revisión.',
    validations_biometric_title_processing: 'Tu identidad está en revisión.',
    validations_biometric_id_description:
        'De esta manera, nos ayudas a verificar y respaldar que eres el titular de la cuenta con la que envías tu saldo',

    validations_selfie_title_default: 'Agrega tu selfie.',
    validations_selfie_title_pre_approved: 'Tu selfie fue aprobada.',
    validations_selfie_title_approved: 'Tu selfie fue aprobada.',
    validations_selfie_title_pending: 'Tu selfie está en revisión.',
    validations_selfie_title_processing: 'Tu selfie está en revisión.',
    validations_selfie_description: 'Esto nos ayuda a verificar tu identidad y mantener la seguridad en la plataforma.',

    validations_facebook_title_default: 'Antes de continuar, agréganos a Facebook.',
    validations_facebook_title_pre_approved: 'Tu validación fue aprobada.',
    validations_facebook_title_approved: 'Tu validación fue aprobada.',
    validations_facebook_title_pending: 'Tu validación en revisión.',
    validations_facebook_title_processing: 'Tu validación en revisión.',
    validations_facebook_description:
        'Este proceso nos permite validar tu usuario y comunicarnos rápidamente a través del chat, en caso que sea necesario.',

    validations_screenshot_title_default: 'Aguardamos los comprobantes de tus pagos.',
    validations_screenshot_title_pre_approved: 'Tus comprobantes de pago fueron aprobados.',
    validations_screenshot_title_approved: 'Tus comprobantes de pago fueron aprobados.',
    validations_screenshot_title_pending: 'Tus comprobantes de pago estan en revisión.',
    validations_screenshot_title_processing: 'Tus comprobantes de pago estan en revisión.',
    validations_screenshot_description:
        'Marcaste que enviaste el saldo, ahora necesitamos los comprobantes de tus pagos. Recuerda que deben ser desde tu cuenta.',

    validations_review_examples_title: 'Si tienes dudas, puedes consultar los',
    validations_review_examples_link: 'ejemplos de cómo subir la documentación.',

    validations_approve_time_message: 'Último documento aprobado hace {{minutes}} min.',

    validations_create_button: 'Enviar a revisión',
    validations_cancel_button: 'Cancelar',

    validations_file_uploader_drag_text: 'Arrastra y suelta la/las imágenes aquí, pega con Ctrl+V o búscalas en tu ordenador',
    validations_file_uploader_uploading: 'Subiendo...',

    validations_facebook_instruction_1: 'Utiliza tu perfil personal, ingresa a nuestro perfil y agréganos como amigo.',
    validations_facebook_instruction_2: 'Envíanos un mensaje como este:',
    validations_facebook_message_template: 'Hola, mi pedido en saldo es: *********',

    validations_empty_message: 'No se encontraron validaciones para completar.',

    validations_examples_title: 'Ejemplos de documentación',
    validations_examples_zoom_instruction: 'Toca una imagen para ampliarla',
    validations_examples_alt_approved: 'aprobado',
    validations_examples_alt_rejected: 'rechazado',
    validations_examples_no_examples: 'No hay ejemplos disponibles para mostrar.',
    validations_examples_alt_prefix: 'Ejemplo',

    validations_examples_title_id: 'Ejemplos de documentación',
    validations_examples_title_screenshot: 'Ejemplos de comprobantes',
    validations_examples_title_selfie: 'Ejemplos de selfie',

    validations_examples_instructions_id:
        "Sube una imagen del anverso y reverso de tu documento de identidad, **bien iluminado y enfocado**, colocado sobre una hoja en blanco con la leyenda **'www.saldo.com.ar'** escrita a mano.",
    validations_examples_instructions_screenshot:
        'Sube foto o captura del **comprobante de pago legible**. Asegurate de que se vea el **monto, fecha y destinatario.**',
    validations_examples_instructions_selfie:
        "Sube una selfie **bien iluminada y enfocada** en la que se vea tu rostro junto con el documento de identidad y una hoja con la frase **'www.saldo.com.ar'** escrita a mano.",

    validations_examples_error_loading: 'Algo falló al cargar los ejemplos. Volvé a intentarlo en unos minutos.',

    validations_example_image_title_default: 'Ejemplo de documentación',
    validations_example_image_title_id: 'Ejemplo de documentación',
    validations_example_image_title_screenshot: 'Ejemplo de comprobante',
    validations_example_image_title_selfie: 'Ejemplo de selfie',
    validations_example_image_approved: 'Imagen aceptada',
    validations_example_image_rejected: 'Imagen rechazada'
};
